import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { createSafeJSONStorage } from '../../helpers/storage/persist-storage';
import { logger } from '../logger/logger';
import { State } from './integrations-store.type';

const useIntegrationsStore = create<State>()(
  devtools(
    persist(
      logger((_) => ({
        integration: null,
        isReauth: false,
        jdcWizard: {
          activeStep: 0,
        },
      })),
      {
        name: 'integrations-store',
        storage: createSafeJSONStorage(() => localStorage),
      },
    ),
  ),
);

export { useIntegrationsStore };
